import React from "react";
import getVideoId from "get-video-id";
import { Modal } from "../Modal";
export default function VideoModal(param) {
    var title = param.title, url = param.url, open = param.open, onClose = param.onClose;
    var videoInfo = getVideoId(url);
    return /*#__PURE__*/ React.createElement(Modal, {
        type: "media",
        open: open,
        onClose: onClose
    }, /*#__PURE__*/ React.createElement("div", {
        className: "overflow-hidden rounded-xl safari-fix-transform"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "w-full aspect-w-16 aspect-h-9"
    }, videoInfo.service === "youtube" && /*#__PURE__*/ React.createElement("iframe", {
        allowFullScreen: true,
        title: title,
        allow: "fullscreen; autoplay; picture-in-picture; encrypted-media;",
        src: "https://www.youtube.com/embed/".concat(videoInfo.id, "?autoplay=1&modestbranding=1")
    }), videoInfo.service === "vimeo" && /*#__PURE__*/ React.createElement("iframe", {
        allowFullScreen: true,
        title: title,
        allow: "fullscreen; autoplay; picture-in-picture; encrypted-media;",
        src: "https://player.vimeo.com/video/".concat(videoInfo.id, "?autoplay=1")
    }), !videoInfo.service && /*#__PURE__*/ React.createElement("iframe", {
        allowFullScreen: true,
        title: title,
        allow: "fullscreen; autoplay; picture-in-picture; encrypted-media;",
        src: url
    }))));
}

//# sourceMappingURL=VideoModal.js.map